import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });

export const Api = {
  events: () => http.get("/events").then((r) => r.data),
  concepts: () => http.get("/concepts").then((r) => r.data),
  stories: () => http.get("/stories").then((r) => r.data),
  tickets: () => http.get("/tickets").then((r) => r.data),
  addons: () => http.get("/addons").then((r) => r.data),
  swishInfo: () => http.get("/payments/swish-info").then((r) => r.data),
  createBooking: (body) => http.post("/bookings", body).then((r) => r.data),
  getBooking: (id) => http.get(`/bookings/${id}`).then((r) => r.data),
  validateInvite: (code) => http.get(`/invites/${code}`).then((r) => r.data),
  ticketQrUrl: (id) => `${API}/bookings/${id}/ticket`,
  createInvite: (body) => http.post("/invites", body).then((r) => r.data),
  createContact: (body) => http.post("/contact", body).then((r) => r.data),
  createCheckout: (body) => http.post("/payments/checkout/session", body).then((r) => r.data),
  checkoutStatus: (sid) => http.get(`/payments/checkout/status/${sid}`).then((r) => r.data),
  sendAdminExport: (token) =>
    http
      .post(`/admin/send-export?token=${encodeURIComponent(token)}`)
      .then((r) => r.data),
  adminBookings: (token) =>
    http
      .get(`/admin/bookings?token=${encodeURIComponent(token)}`)
      .then((r) => r.data),
  adminUpdateBookingStatus: (token, id, status) =>
    http
      .patch(
        `/admin/bookings/${id}?token=${encodeURIComponent(token)}&status=${status}`
      )
      .then((r) => r.data),
};
